import React, { useEffect, useState } from "react"
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  TextField,
  Grid,
  Stack,
  Pagination,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material"
import * as Style from "./style"
import { useJobHistoryQuery } from "../../features/Auth/authApi"
import { Button } from "react-bootstrap"
import { CiSearch } from "react-icons/ci"
import dummy from "../../images/dummy-image.jpg"
import nodata from "../../images/no-results.svg"
import { TbArrowsSort } from "react-icons/tb"
import CenteredSpinner from "../common/CenteredSpinner"
import RatingStars from "../common/rating"
import {
  FormatChangeTime,
  FormatDate,
  FormatTime,
} from "../common/utctolocalDate"
import { useNavigate, useParams, useSearchParams } from "react-router-dom"
import useDebounceCallback from "../../utils/useDebounceCallback"

const statusButton = ["All", "Completed", "Expired", "Declined"]
const JobHistory = () => {
  const [selectedPage, setSelectedPage] = useState(1)
  const [statusChange, setStatusChange] = useState()
  const [searchStatus, setSearchStatus] = useState<string>("")
  const [searchPayload, setSearchPayload] = useState()
  const [dateShortList, setDateShortList] = useState(-1)
  const [pageSelect, setPageSelect] = React.useState<number>(10)
  const [searchParams, setSearchParams] = useSearchParams()
  const [pagiNationLoad, setPagiNationLoad] = useState<boolean>(false)
  const { type } = useParams()
  const navigate = useNavigate()
  const updateSearchParam = (input: string) => {
    const updated = new URLSearchParams(searchParams);
      if (input.trim()) {
        updated.set("search_name", input.trim());
      } else {
        updated.delete("search_name");
      }
      updated.set("pageNo", "1");
      setSearchParams(updated);
  };

  const update = useDebounceCallback(updateSearchParam, 200);
  
  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const input = e.target.value;
    setSearchStatus(input);
    update(input);
  }

  const handlePageChange = (event: any, value: any) => {
    setSelectedPage(value)

    const updated = new URLSearchParams(searchParams);
    updated.set("pageNo", value.toString());
    setSearchParams(updated)
  }

  const {
    data: JobHistory,
    isLoading,
    isFetching,
  } = useJobHistoryQuery(
    {
      pageNo: selectedPage,
      postStatus: statusChange,
      searchName: (searchParams.get("search_name") ?? "")?.trim(),
      createdAt: dateShortList,
      pageLimit: pageSelect,
    },
    {
      refetchOnMountOrArgChange: true,
    },
  )

  const handleButton = (name: any, index: number) => {
    setSearchPayload("" as any)
    setSearchStatus("" as any)

    setStatusChange(name)
  }

  useEffect(() => {
    setStatusChange(type as any)
  }, [type])

  const handleSDateShort = () => {
    const shortDate = dateShortList === 1 ? -1 : 1
    setDateShortList(shortDate)
  }
  const handleChange = (event: any, name: any) => {
    setPageSelect(event.target.value)
    setSelectedPage(1)
  }

  useEffect(() => {
    const page = searchParams.get("pageNo");
  
    if (!page) {
      const updated = new URLSearchParams(searchParams);
      updated.set("pageNo", "1");
      setSearchParams(updated);
    }
  }, []);
  return (
    <>
      <Style.Overview>
        <Box className="d-flex flex-column mb-3">
          {/* Search and View in same row on desktop, stacked on mobile */}
          <Box className="d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between mb-3">
            {/* Search Field */}
            <Box className="d-flex flex-none w-100 max-w-550 mb-3 mb-md-0 me-0 me-md-3">
              <TextField
                id="outlined-basic"
                className="search-field flex-grow-1"
                label="Search"
                variant="outlined"
                onChange={handleSearch}
                value={searchStatus}
              />
              <Button
                variant="contained"
                className="search-btn ms-0"
              >
                <CiSearch />
              </Button>
            </Box>

            {/* View Field - Right side on desktop, below search on mobile */}
            <Box className="w-100 w-md-auto">
              <FormControl
                sx={{ 
                  m: 1, 
                  mt: 1,
                  minWidth: { xs: "100%", md: 200 },
                  width: { xs: "calc(100% - 16px)", md: "auto" }
                }}
                className="custom-field view-field"
              >
                <InputLabel
                  id="demo-simple-select-label"
                  className="label-with-icon"
                >
                  View
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  label="Age"
                  value={pageSelect}
                  onChange={(event) => handleChange(event, "page" as any)}
                >
                  <MenuItem value={10}>10</MenuItem>
                  <MenuItem value={20}>20</MenuItem>
                  <MenuItem value={30}>30</MenuItem>
                </Select>
              </FormControl>
            </Box>
          </Box>

          {/* Status Buttons */}
          <Box className="w-100">
            {statusButton?.map((item, index) => (
              <Button
                key={index}
                variant="transparent"
                className="all-button mb-2 me-2"
                style={{
                  backgroundColor:
                    statusChange === item ? "#F475A4" : "white",
                  color: statusChange === item ? "white" : "black",
                  borderColor: statusChange === item ? "white" : "transparent",
                  padding: "6px 20px",
                  boxShadow: "0px 4px 25px 0px rgba(0, 0, 0, 0.07)",
                }}
                onClick={() => handleButton(item, index)}
              >
                {item}
              </Button>
            ))}
          </Box>
        </Box>

        {isLoading || isFetching || pagiNationLoad ? (
          <CenteredSpinner />
        ) : (
          <>
            <>
              <TableContainer
                component={Paper}
                className="dashboard-table-wrapper custom-scrollbar"
              >
                <Table
                  sx={{
                    marginBottom: "20px",
                    minWidth: 650,
                    border: "none",
                    backgroundColor: "transparent",
                  }}
                  className="dashboard-table"
                  aria-label="simple table"
                >
                  {JobHistory?.data?.length > 0 && (
                    <TableHead>
                      <TableRow>
                        <TableCell></TableCell>
                        <TableCell align="center" className="service-head">
                          Name{" "}
                        </TableCell>

                        <TableCell align="center">Service</TableCell>
                        <TableCell align="center">Language</TableCell>
                        <TableCell align="center" onClick={handleSDateShort}>
                          Start Time <TbArrowsSort />
                        </TableCell>
                        <TableCell align="center">Status</TableCell>
                      </TableRow>
                    </TableHead>
                  )}
                  <TableBody>
                    {JobHistory?.data?.length > 0 ? (
                      JobHistory?.data?.map((row: any) => (
                        <TableRow
                          key={row._id}
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            navigate(`/dashboard/approved-detail/${row?._id}`),
                              setSearchParams({ view: "booking-detail" })
                          }}
                        >
                          <TableCell>
                            <div
                              style={{
                                width: "74px",
                                height: "74px",
                                objectFit: "cover",
                              }}
                            >
                              <img
                                src={row.userimage || dummy}
                                style={{
                                  width: "74px",
                                  height: "74px",
                                  objectFit: "cover",
                                }}
                              />
                            </div>
                          </TableCell>
                          <TableCell component="td" align="center" scope="row">
                            <span className="text flex-column gap-2">
                              {row.seekerData?.name + " " || "-----"}
                              <span className="minh-1">
                                <RatingStars
                                  rating={
                                    row?.seekerData?.rating?.$numberDecimal
                                  }
                                />
                              </span>
                            </span>
                          </TableCell>

                          <TableCell align="center">
                            <span>{row?.service?.name || "-----"}</span>
                          </TableCell>
                          <TableCell align="center">
                            <span className="language text-center mx-auto">
                              <span>{(row.language || []).join(", ") || "-----"}</span>
                            </span>
                          </TableCell>
                          <TableCell align="center">
                            <span className="datetime">
                              <span className="d-flex flex-column">
                                <span className="weekday">
                                  <FormatDate dateString={row?.from} />
                                </span>

                                <span>
                                  <FormatChangeTime dateString={row?.from} />
                                </span>
                                <span>
                                  <FormatTime dateString={row?.from} />
                                </span>
                              </span>
                            </span>
                          </TableCell>
                          <TableCell align="center">
                            <span
                              className={row.requeststatus}
                              style={{
                                fontSize: "14px",
                                fontWeight: "bold",
                                color:
                                  row?.status == "Completed"
                                    ? "green"
                                    : row?.status == "Expired"
                                    ? "red "
                                    : row?.status == "Declined"
                                    ? "yellow"
                                    : "",
                              }}
                            >
                              {row?.status}
                            </span>
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <>
                        <TableRow
                          sx={{
                            height: "40vh",
                            backgroundColor: "white",
                          }}
                        >
                          {" "}
                          <TableCell
                            align="center"
                            colSpan={7}
                            sx={{
                              width: "100%",
                              pointerEvents: "none",
                              border: "none",
                            }}
                          >
                            <img
                              src={nodata}
                              style={{
                                width: "100%",
                                maxWidth: "180px",
                              }}
                            />
                            <span
                              className="no-data-text"
                              style={{
                                fontSize: "20PX",
                                fontWeight: "600",
                                color: "#000",
                              }}
                            >
                              No Data Found
                            </span>
                          </TableCell>
                        </TableRow>
                      </>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>

              {JobHistory?.data?.length > 0 && (
                <Box className="d-md-flex justify-content-between pt-2">
                  <Typography variant="body1" className="w-auto white-space">
                    {" "}
                    Showing {JobHistory?.totalDocument?.showingData} -{" "}
                    {JobHistory?.totalDocument?.showingEnd} of{" "}
                    {JobHistory?.totalDocument?.totalCount}
                  </Typography>
                  <Grid container justifyContent="flex-end">
                    <Grid item md={3}>
                      <Box display="flex" className="flex-column">
                        <Stack spacing={0} className="mb-3">
                          <Pagination
                            count={JobHistory?.totalDocument?.totalPages}
                            color="secondary"
                            className="custom-pagination"
                            page={JobHistory?.totalDocument?.pageNo}
                            onChange={handlePageChange}
                            sx={{
                              "& .MuiPaginationItem-page.Mui-selected": {
                                backgroundColor: "#F475A4",
                                boxSizing: "border-box",
                              },
                              "& .MuiPagination-ul": {
                                justifyContent: "end",
                                flexWrap: "nowrap",
                              },
                            }}
                          />
                        </Stack>
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
              )}
            </>
          </>
        )}
      </Style.Overview>
    </>
  )
}

export default JobHistory
